import styled from "styled-components";

const MoreReasonsToJoin = () => {
  const items = [
    {
      title: "Get access to full length movies and beyond",
      desc: "Be the first to explore limited release productions and members only premiere that you won’t find anywhere else.",
      iconSrc: "/icons/beyond.svg",
    },
    {
      title: "Exclusive Access & Early Releases",
      desc: "Be the first to explore limited release productions and members only premiere that you won’t find anywhere else",
      iconSrc: "/icons/early.svg",
    },
    {
      title: "Seemless enhanced streaming anywhere",
      desc: "Enjoy cinematic performance with enhanced picture quality across all your devices",
      iconSrc: "/icons/stream.svg",
    },
    {
      title: "Private. Secure. Yours.",
      desc: "Your viewing stays yours alone. With advanced privacy protection your experience is completely discreet and secure",
      iconSrc: "/icons/secure.svg",
    },
  ];

  return (
    <Section>
      <Title>More Reasons To Join</Title>

      <Inner>
        <Grid>
          {items.map((item) => (
            <Card key={item.title}>
              <CardTitle>{item.title}</CardTitle>
              <CardDesc>{item.desc}</CardDesc>

              <IconCorner>
                <IconImg src={item.iconSrc} alt="" aria-hidden="true" />
              </IconCorner>
            </Card>
          ))}
        </Grid>
      </Inner>
    </Section>
  );
};

export default MoreReasonsToJoin;

/* Styles matched to your TrendingSection spacing */

const Section = styled.section`
  padding: 0;
  background: #000;
  color: #fff;
  margin-top: 52px;

  @media (max-width: 568px) {
    margin-top: 34px;
  }
`;

const Title = styled.h2`
  font-size: 28px;
  font-weight: 700;
  margin-bottom: 18px;
  text-align: left;

  padding-left: clamp(0px, 4vw, 80px);
  padding-right: clamp(0px, 4vw, 80px);

  @media (max-width: 568px) {
    font-size: 22px;
  }
`;

const Inner = styled.div`
  padding-left: clamp(0px, 4vw, 80px);
  padding-right: clamp(0px, 4vw, 80px);
  padding-bottom: 28px;

  @media (max-width: 568px) {
    padding-bottom: 18px;
  }
`;

const Grid = styled.div`
  display: grid;
  gap: 16px;
  grid-template-columns: repeat(4, 1fr);

  @media (max-width: 1100px) {
    grid-template-columns: repeat(2, 1fr);
  }
 @media (max-width: 868px) {
    grid-template-columns: 1fr;
  }
  @media (max-width: 568px) {
    grid-template-columns: 1fr;
  }
`;

const Card = styled.div`
  position: relative;
  overflow: hidden;
  border-radius: 16px;

  aspect-ratio: 4 / 5;
  padding: 20px 18px 64px;

  background: linear-gradient(135deg, #192145 0%, #2a0028 100%);



  &::after {
    content: "";
    position: absolute;
    inset: 0;
    background: radial-gradient(
        circle at 22% 12%,
        rgba(255, 255, 255, 0.08) 0%,
        rgba(255, 255, 255, 0) 45%
      ),
      radial-gradient(
        circle at 88% 92%,
        rgba(0, 0, 0, 0.25) 0%,
        rgba(0, 0, 0, 0) 60%
      );
    pointer-events: none;
  }
  /* 0 to 868: keep height stable while width expands smoothly */
  @media (max-width: 868px) {
    aspect-ratio: auto;
    height: 190px; /* adjust if you want */
  }

  /* 0 to 568: your mobile ratio, but keep same height behavior */
  @media (max-width: 568px) {
    aspect-ratio: 5 / 2;
    height: auto; /* ratio controls it on small screens */
  }
`;

const CardTitle = styled.h3`
  position: relative;
  z-index: 1;

  font-size: 27px;
  font-weight: 800;
  color: #fff;
  margin: 0 0 10px;
  line-height: 1.15;

  @media (max-width: 568px) {
    font-size: 18px;
  }
`;

const CardDesc = styled.p`
  position: relative;
  z-index: 1;

  margin: 0;
  font-size: 17px;
  line-height: 1.4;
  color: rgba(255, 255, 255, 0.68);
  max-width: 95%;
`;

const IconCorner = styled.div`
  position: absolute;
  right: 4px;
  bottom: -4px;
  width: 162px;
  height: 162px;
  display: grid;
  place-items: center;
  z-index: 1;
  pointer-events: none;

    @media (max-width: 568px) {
  right: -1px;
  bottom: -18px;;
  }
`;

const IconImg = styled.img`
  width: 196px;
  height: 196px;
  object-fit: contain;
  
`;
